import { MenuAction } from '@shared/interfaces/header/menu-action';
import { Eye, EyeOff } from 'lucide-angular';

export const meteringpointTransactionsActionMenu: MenuAction[] = [
  {
    id: 'show',
    title: 'common.show',
    icon: Eye,
  },
  {
    id: 'toggle-tidsserier',
    title: 'meteringpoint.businesstransaction.hidetidsserier',
    icon: EyeOff,
  },
];
